import "./Students.css";
import React from "react";
import { MoonLoader } from "react-spinners";
import { BaseURL } from "../../Hooks/URL";
import TextFieldInput from "../../Components/Atoms/Inputs/TextField/TextFieldInput";
import { images } from "../../Assets/assetsHelper";
import Filter from "../../Components/Molecules/Filter/Filter";
import { Pagination } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import AddIcon from "@mui/icons-material/Add";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";
import SchoolIcon from "@mui/icons-material/School";
import CakeIcon from "@mui/icons-material/Cake";
import BadgeIcon from "@mui/icons-material/Badge";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import SortButton from "../../Components/Molecules/SortButton/SortButton";
import { getGradeName } from "../../Assets/grades";

function Students({
  page,
  searchData,
  search,
  setSearchData,
  setSearch,
  students,
  navigate,
  handleChangePage,
  loading,
  pageCount,
  setFilter,
  role,
  totalCount,
  setSort,
  currentSort,
}) {
  // if (loading) {
  //   return (
  //     <div className="mainContainer">
  //       <div className="loadingContainer">
  //         <MoonLoader color="#012369" size={40} />
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="mainContainer">
      {/* Page Header */}
      <div className="pageHeader">
        <div className="pageTitle">
          <div className="titleIcon">
            <PersonIcon />
          </div>
          <div className="titleContent">
            <h1>Students Management</h1>
            <p>Manage and view all registered students</p>
          </div>
        </div>

        {(role === "admin" || role === "school") && (
          <button
            className="actionButton primary addButton"
            onClick={() => navigate("/students/add")}
          >
            <AddIcon />
            Add Student
          </button>
        )}
      </div>

      {loading ? (
        ""
      ) : (
        <>
          {/* Statistics Cards */}
          <div className="statsGrid">
            <div className="statCard">
              <div className="statIcon primary">
                <PersonIcon />
              </div>
              <div className="statContent">
                <h4>Total Students</h4>
                <h2>{totalCount || 0}</h2>
              </div>
            </div>
            <div className="statCard">
              <div className="statIcon success">
                <SchoolIcon />
              </div>
              <div className="statContent">
                <h4>Enrolled Students</h4>
                <h2>{0}</h2>
              </div>
            </div>
            <div className="statCard">
              <div className="statIcon warning">
                <CakeIcon />
              </div>
              <div className="statContent">
                <h4>Active Students</h4>
                <h2>{0}</h2>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Students Cards */}
      <div className="contentSection">
        <div className="tableHeader">
          <h2 className="sectionTitle">Students List</h2>
        </div>

        <div className="searchFilterHeader">
          <div className="searchFilterGroup">
            <TextFieldInput
              searchIcon={true}
              Required={false}
              type="text"
              placeholder={"Search students..."}
              className="modernSearchBar"
              name={"search"}
              change={(e) => setSearchData(e.target.value)}
              newValue={searchData}
              searchAction={() => {
                if (search !== searchData) {
                  setSearch(searchData);
                }
              }}
              keyDown={(e) => {
                if (e.keyCode === 13) {
                  if (search !== searchData) {
                    setSearch(searchData);
                  }
                }
              }}
            />
            <Filter Gender schools Grades setFilter={setFilter} />
            <SortButton
              setSort={setSort}
              currentSort={currentSort}
              name
              createdAt
            />
          </div>
        </div>

        {loading ? (
          ""
        ) : (
          <>
            <div className="tableHeaderCount">
              <div className="tableActions">
                <span className="resultsCount">
                  Showing {students?.length || 0} students
                </span>
              </div>
            </div>
          </>
        )}

        {loading ? (
          <div className="loadingContainer">
            <MoonLoader color="#012369" size={40} />
          </div>
        ) : (
          <>
            {students && students.length > 0 ? (
              <div className="studentsGrid">
                {students.map((student) => (
                  <div
                    key={student.id}
                    className="studentCard"
                    onClick={() => navigate(`/students/${student.id}`)}
                  >
                    <div className="studentAvatar">
                      {student?.photoFilePath ? (
                        <img
                          alt="student photo"
                          src={`${BaseURL}/${student?.photoFilePath}`}
                          className="studentPhoto"
                        />
                      ) : (
                        <div className="studentLogoPlaceholderSmall">
                          <PersonIcon style={{ fontSize: "48px" }} />
                        </div>
                      )}
                    </div>

                    <div className="studentInfo">
                      <h3 className="studentNameSmall">{student?.name}</h3>

                      <div className="studentDetails">
                        <div className="detailItem">
                          <span className="detailLabel">National ID:</span>
                          <span className="detailValue">
                            {student?.nationalId || "N/A"}
                          </span>
                        </div>
                        <div className="detailItem">
                          <span className="detailLabel">Gender:</span>
                          <span className="detailValue">
                            {student?.gender == "male" ? "Male" : "Female"}
                          </span>
                        </div>
                        <div className="detailItem">
                          <span className="detailLabel">Grade:</span>
                          <span className="detailValue">
                            {getGradeName(student?.grade) || "N/A"}
                          </span>
                        </div>

                        {role === "admin" && (
                          <div className="detailItem">
                            <span className="detailLabel">School:</span>
                            <span className="detailValue">
                              <SchoolIcon className="schoolIcon" />
                              {student?.school?.name || "N/A"}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="emptyState">
                <div className="emptyIcon">
                  <PersonIcon />
                </div>
                <h3>No Students Found</h3>
                <p>
                  No students have been added yet. Start by adding your first
                  student.
                </p>
                {(role === "admin" || role === "school") && (
                  <button
                    className="actionButton primary"
                    onClick={() => navigate("/students/add")}
                    style={{ margin: "20px auto" }}
                  >
                    <AddIcon />
                    Add First Student
                  </button>
                )}
              </div>
            )}
          </>
        )}

        {loading ? (
          ""
        ) : (
          <>
            {/* Pagination */}
            {students && students.length > 0 && (
              <div className="paginationContainer">
                <Pagination
                  count={pageCount}
                  page={page + 1}
                  onChange={handleChangePage}
                  size="large"
                  color="primary"
                  className="paginationCount"
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Students;
